import { Share2, CreditCard, Gift } from "lucide-react";

const PASSOS = [
  {
    icon: Share2,
    titulo: "1. Compartilhe seu código",
    texto: "O novo estabelecimento informa seu código em Assinatura, antes de pagar a primeira mensalidade.",
  },
  {
    icon: CreditCard,
    titulo: "2. Ele paga a primeira mensalidade",
    texto: "O prêmio só vale quando a indicação vira cliente pagante de verdade.",
  },
  {
    icon: Gift,
    titulo: "3. Você ganha 2 meses",
    texto: "Suas duas próximas faturas saem zeradas, sem precisar pedir nada.",
  },
];

export default function ComoFunciona({ mesesPorIndicacao = 2 }) {
  return (
    <div className="space-y-4">
      <div className="grid gap-4 md:grid-cols-3">
        {PASSOS.map(({ icon: Icon, titulo, texto }) => (
          <div key={titulo} className="rounded-2xl border bg-card p-5">
            <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center mb-3">
              <Icon className="w-5 h-5 text-primary" />
            </div>
            <h3 className="font-semibold mb-1">{titulo}</h3>
            <p className="text-sm text-muted-foreground">{texto}</p>
          </div>
        ))}
      </div>

      {/* As regras que evitam chamado de suporte depois. Cada linha aqui existe
          porque e' uma duvida real que o modelo levanta. */}
      <div className="rounded-2xl border bg-muted/30 p-5">
        <h3 className="font-semibold mb-3 text-sm">Regras do programa</h3>
        <ul className="text-sm text-muted-foreground space-y-2">
          <li>
            • Cada indicado rende {mesesPorIndicacao} meses{" "}
            <strong className="text-foreground">uma única vez</strong>, no
            primeiro pagamento dele. As mensalidades seguintes não geram novo
            prêmio.
          </li>
          <li>
            • Não há limite de indicações: 5 indicados que pagam valem{" "}
            {mesesPorIndicacao * 5} meses grátis.
          </li>
          <li>
            • Os meses são usados automaticamente nas próximas faturas, uma por
            vez, e aparecem lá como “Mês grátis do Indique e Ganhe”.
          </li>
          <li>
            • Os créditos não expiram e não viram dinheiro — só abatem
            mensalidade.
          </li>
          <li>
            • O código é informado pela loja indicada em{" "}
            <strong className="text-foreground">Assinatura</strong> e pode ser mudado até a
            primeira mensalidade ser paga. Depois disso a indicação fica travada.
          </li>
          <li>
            • Indicar a si mesmo não vale. O código precisa ser usado por outro
            estabelecimento.
          </li>
        </ul>
      </div>
    </div>
  );
}
